<template>
  <view class="desc">
    <slot></slot>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    addGlobalClass: true,
    styleIsolation: 'shared'
  }
})
</script>

<style lang="stylus">
.desc
  font-size 12px
  color #4B4B4D
  line-height 18px
  margin-bottom 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true
  }
</script>
